import React, {useEffect, useState} from 'react';

import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';

import {
  Button,
  IconButton,
  Grid,
  Menu,
  MenuItem,
  Paper,
  Chip
} from '@mui/material';

import {
  blue,
  lightBlue,
  grey,
  blueGrey,
  teal
} from '@mui/material/colors';

import HeroSection from './HeroSection';
import CarouselSection from './CarouselSection';
import ServiceSection from './ServiceSection';
import NewsSection from './NewsSection';
import CtaSection from './CtaSection';

import axios from "axios";
import moment from 'moment';
import 'moment/locale/ko';

function DashboardPage(props) {

  return (
    <React.Fragment>

      {/* hero 섹션을 추가: 화면 상단에 풀스크린 히어로 배너를 표시합니다. */}
      <HeroSection />

      <CarouselSection />

      <Container>
        <ServiceSection />
        <NewsSection />
      </Container>
      <CtaSection />
    </React.Fragment>
  );
}

export default DashboardPage;
